<template>
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="ibox-content m-b-sm border-bottom">
        <div class="row form-horizontal">
          <div class="form-group margin-0">
            <label class="col-sm-2 control-label"> Category Name </label>
            <div class="col-sm-4">
              <div>
                <el-input v-model="categoryName" name="search"></el-input>
              </div>
            </div>
            <div class="col-sm-4 textRight">
              <div class>
                <el-button type="primary" @click="search">{{
                  $t("message.Search")
                }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              <div class="row table-responsive" style="padding-bottom: 60px">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button
                      @click="gotoDetail"
                      
                      >{{ $t("message.Add") }}</el-button
                    >
                    <!-- v-if="checkPermission('NEW_LIST_ADD')" -->
                    <el-button
                      @click="showWarning"
                      >{{ $t("message.Delete") }}</el-button
                    >
                    <!-- v-if="checkPermission('NEW_LIST_DEL')" -->
                  </div>
                </div>
                <div class="col-xs-12">
                  {{ total }}{{ $t("message.datagridresult") }}
                </div>
                <el-table
                  :data="rows"
                  border
                  style="width: 100%"
                  ref="multipleTable"
                  @selection-change="handleSelectionChange"
                  row-key="id"
                  :cell-class-name="cell"
                >
                  <el-table-column type="selection" width="55"></el-table-column>
                  <el-table-column prop="categoryNameEn" label="Category Name">
                  </el-table-column>
                  <el-table-column label="Action" width="70" fixed="right">
                    <template slot-scope="scope">
                      <el-row>
                        <el-col :span="24"
                          ><el-button
                            size="mini"
                            @click="handleDbClick(scope.row)"
                            icon="el-icon-edit"
                          ></el-button
                        ></el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                </el-table>
                <el-col :span="24" class="el-table_footertoolbar">
                  <el-pagination
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pagesize"
                    :total="total"
                    style="float: right"
                  >
                  </el-pagination>
                </el-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import config from "../config";
  import Sortable from "sortablejs";
  import StatusBtn from "../components/common/statusBtn.vue";
  
  export default {
    mixins: [config.globalMixin],
    data() {
      return {
        page: 1, //当前页数
        pagesize: 10, //一页显示几条
        filter: "",
        name: "",
        searchStatus: null,
        total: 0,
        rows: [],
        multipleSelection: [],
        status: "",
        statusObj: [],
        typeObj: [],
        type: "",
        status: "",
        startDate: "",
        endDate: "",
        period: null,
        canDrag: true,
        categoryName: "",
      };
    },
    components: {
      StatusBtn,
    },
    created: function () {},
    methods: {
      async init() {
        this.canDrag = true;
        var objdata = this.getAuthObj();
  
        objdata.pageIndex = this.page;
        objdata.pageSize = this.pagesize;
        objdata.categoryName = this.categoryName;
        objdata.type = "publicity_category"
  
        objdata.apiUrl = this.apiConfig.giftCategoryList;
        let data = await this.$store.dispatch("apiEvent", objdata);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        this.rows = data.data.result.giftCategoryList;
        this.setObj();
        this.total = data.data.result.total;
      },
      getStatus(data) {
        if (data.indexOf("all") < 0) {
          this.searchStatus = Number(data);
        } else {
          this.searchStatus = null;
        }
      },
      async search() {
        this.page = 1;
        this.init();
      },
      cancel: function () {
        this.$store.commit("setwarning", { string: "", boolean: false });
      },
      cell: function ({ row }) {
        // if (!this.canDrag) {
        //   return "disabled pointer";
        // }
        // if (row.status == 1) {
        //   return "cursor-move";
        // } else {
        //   return "disabled pointer";
        // }
      },
      handleDbClick: function (row) {
        this.$router.push({
          path: "/main/giftCategoryDetail",
          query: {
            id: row.id,
          },
        });
      },
      gotoDetail() {
        this.$router.push({ path: "/main/giftCategoryDetail" });
      },
      async deleteList() {
        let ids = [];
        let objdata = this.getAuthObj();
        if (this.multipleSelection.length != 0) {
          for (let i = 0; i < this.multipleSelection.length; i++) {
            ids.push(this.multipleSelection[i].id);
          }
        }
        objdata.ids = ids.join(",");
  
        objdata.apiUrl = this.apiConfig.giftCategoryDelete;
        let data = await this.$store.dispatch("apiEventFromData", objdata);
        if (data == "000104") {
          this.timeoutEvent();
          return;
        }
        if (!data) return;
        if (data.data.status_code === "0") {
          this.$store.commit("setwarning", {
            string: "",
            boolean: false,
            button: [],
          });
          this.init();
        }
      },
      setObj: function () {
        this.statusObj = [
          {
            value: "1",
            label: this.$i18n.t("message.Active"),
          },
          {
            value: "0",
            label: this.$i18n.t("message.Inactive"),
          },
        ];
        this.typeObj = [
          {
            value: 0,
            label: "Broadcast message",
          },
          {
            value: 1,
            label: "Promotion",
          },
        ];
        let list = null;
        for (list of this.rows) {
          if (list.status === 0) {
            list.statusName = "Draft";
          } else if (list.status == 1) {
            list.statusName = "Pending approval";
          } else if (list.status == 2) {
            list.statusName = "Pending Publish";
          } else if (list.status == 3) {
            list.statusName = "Rejected";
          } else if (list.status == 4) {
            list.statusName = "Suspended";
          } else if (list.status == 5) {
            list.statusName = "Pending Suspend";
          } else if (list.status == 6) {
            list.statusName = "Published";
          }
        }
      },
    },
    mounted() {
      this.init();
    },
  };
  </script>
  